<template>
  <div class="description column"
       :title="item.description">
    {{item.description}}
  </div>
</template>

<script>
export default {
  name: 'IssueDescriptionTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.description {
  max-height: rem(48);
  width: fit-content;

  color: var(--text-primary);
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(16);

  overflow: hidden;
}
</style>
